<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
  >
    <path
      d="M14.5 18C14.9167 18 15.271 17.854 15.563 17.562C15.855 17.27 16.0007 16.916 16 16.5C16 16.0833 15.854 15.729 15.562 15.437C15.27 15.145 14.916 14.9993 14.5 15C14.0833 15 13.729 15.146 13.437 15.438C13.145 15.73 12.9993 16.084 13 16.5C13 16.9167 13.146 17.271 13.438 17.563C13.73 17.855 14.084 18.0007 14.5 18ZM9.45 17.95L15.95 11.45L14.55 10.05L8.05 16.55L9.45 17.95ZM9.5 13C9.91667 13 10.271 12.854 10.563 12.562C10.855 12.27 11.0007 11.916 11 11.5C11 11.0833 10.854 10.729 10.562 10.437C10.27 10.145 9.916 9.99933 9.5 10C9.08333 10 8.729 10.146 8.437 10.438C8.145 10.73 7.99933 11.084 8 11.5C8 11.9167 8.146 12.271 8.438 12.563C8.73 12.855 9.084 13.0007 9.5 13ZM12 22C9.71667 22 7.81233 21.2167 6.287 19.65C4.76167 18.0833 3.99933 16.1333 4 13.8C4 12.1333 4.66267 10.3207 5.988 8.362C7.31333 6.40333 9.31733 4.28267 12 2C14.6833 4.28333 16.6877 6.40433 18.013 8.363C19.3383 10.3217 20.0007 12.134 20 13.8C20 16.1333 19.2373 18.0833 17.712 19.65C16.1867 21.2167 14.2827 22 12 22ZM12 20C13.7333 20 15.1667 19.4123 16.3 18.237C17.4333 17.0617 18 15.5827 18 13.8C18 12.5833 17.4957 11.2083 16.487 9.675C15.4783 8.14167 13.9827 6.46667 12 4.65C10.0167 6.46667 8.521 8.14167 7.513 9.675C6.505 11.2083 6.00067 12.5833 6 13.8C6 15.5833 6.56667 17.0627 7.7 18.238C8.83333 19.4133 10.2667 20.0007 12 20Z"
      fill="#213E7A"
    />
  </svg>
</template>

<script>
export default {
    name:'IconHumiBig'
};
</script>

<style></style>
